import { Wand2, CheckCircle2, Circle, ShieldCheck, AlertTriangle, ArrowRight } from "lucide-react";

const SOURCE_STYLE = {
  Organisation: { bg: "var(--sarcelle-p, #E5F0F0)", fg: "var(--sarcelle)" },
  Site: { bg: "var(--vert-p)", fg: "var(--vert)" },
  Zone: { bg: "var(--ambre-p, #FDF3E0)", fg: "var(--ambre, #B26A00)" },
  Entreprise: { bg: "#EAE6F7", fg: "#5B3FBF" },
};

// Brique 3 « 5 premières minutes » : montre ce que PERMIT&CO connaît déjà de l'environnement
// (données maîtres fiables), sans donner l'impression de remplir un PDP numérique.
export default function PreparationPanel({ items = [], repris = 0, aCompleter = [], onGoTo }) {
  return (
    <div className="card prep-panel" data-testid="prep-panel" style={{ borderLeft: "4px solid var(--sarcelle)" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
        <Wand2 size={18} color="var(--sarcelle)" />
        <h3 style={{ fontSize: ".98rem", margin: 0 }}>PERMIT&CO prépare votre intervention</h3>
      </div>
      <p style={{ fontSize: ".8rem", color: "var(--text-muted)", margin: "0 0 12px" }}>
        Nous reprenons automatiquement ce que nous connaissons déjà de votre environnement.
      </p>

      {items.length === 0 ? (
        <div className="empty" data-testid="prep-empty" style={{ textAlign: "left", padding: "6px 0", fontSize: ".84rem" }}>
          Sélectionnez un site, une zone ou une entreprise : PERMIT&CO préremplira automatiquement les informations réutilisables.
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {items.map((it) => {
            const ss = SOURCE_STYLE[it.source] || { bg: "var(--ligne)", fg: "var(--text-main)" };
            const verifier = it.fiabilite === "verifier";
            return (
              <div key={it.cle} data-testid={`prep-item-${it.cle}`}
                style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: ".84rem" }}>
                <CheckCircle2 size={15} color="var(--vert)" style={{ flexShrink: 0, marginTop: 2 }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 6 }}>
                    <b>{it.label} récupéré{it.label.endsWith("s") ? "s" : ""}</b>
                    <span data-testid={`prep-source-${it.cle}`} style={{
                      fontSize: ".66rem", fontWeight: 700, padding: "1px 7px", borderRadius: 20,
                      background: ss.bg, color: ss.fg, textTransform: "uppercase", letterSpacing: ".03em",
                    }}>{it.source}</span>
                    <span style={{
                      display: "inline-flex", alignItems: "center", gap: 3, fontSize: ".68rem", fontWeight: 600,
                      color: verifier ? "var(--ambre, #B26A00)" : "var(--vert)",
                    }}>
                      {verifier ? <AlertTriangle size={11} /> : <ShieldCheck size={11} />}
                      {verifier ? "À vérifier" : "Fiable"}
                    </span>
                  </div>
                  {it.valeur && <div style={{ color: "var(--text-muted)", fontSize: ".78rem", marginTop: 1 }}>{it.valeur}</div>}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Compteur des « 5 premières minutes » : uniquement le nécessaire pour CRÉER l'intervention */}
      <div data-testid="prep-counter" style={{
        marginTop: 14, padding: "10px 12px", borderRadius: 8,
        background: aCompleter.length ? "var(--ambre-p, #FDF3E0)" : "var(--vert-p)",
        border: `1px solid ${aCompleter.length ? "var(--ambre, #E49B1A)" : "var(--vert)"}`,
      }}>
        <div style={{ fontSize: ".66rem", fontWeight: 700, letterSpacing: ".05em", textTransform: "uppercase", color: "var(--text-muted)", marginBottom: 4 }}>
          Périmètre : créer l'intervention et lancer son analyse
        </div>
        <div style={{ fontSize: ".86rem" }}>
          <b data-testid="prep-repris">{repris}</b> information{repris > 1 ? "s" : ""} reprise{repris > 1 ? "s" : ""} automatiquement
          {" — "}
          <b data-testid="prep-acompleter">{aCompleter.length}</b> reste{aCompleter.length > 1 ? "nt" : ""} à compléter
        </div>
        {aCompleter.length > 0 && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 }}>
            {aCompleter.map((c) => (
              <button key={c.key} type="button" data-testid={`prep-todo-${c.key}`}
                onClick={() => onGoTo && onGoTo(c.step, c.field)}
                style={{
                  display: "inline-flex", alignItems: "center", gap: 4, fontSize: ".76rem",
                  padding: "3px 9px", borderRadius: 20, cursor: "pointer",
                  background: "var(--surface)", border: "1px solid var(--ambre, #E49B1A)", color: "var(--text-main)",
                }}>
                <Circle size={9} />{c.label}<ArrowRight size={11} />
              </button>
            ))}
          </div>
        )}
      </div>
      <p style={{ fontSize: ".76rem", color: "var(--text-muted)", margin: "10px 0 0" }}>
        Il ne vous reste à renseigner que ce qui est spécifique à cette intervention.
      </p>
    </div>
  );
}
